import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { costReadPermission } from '@platform/plugin-cost-common';
import EuroSymbolIcon from '@material-ui/icons/EuroSymbol';
import { costApiRef } from './api/CostApi';
import { CostClient } from './api/CostClient';
import { rootRouteRef } from './routes';

const costPage = PageBlueprint.make({
  params: {
    path: '/costs',
    routeRef: rootRouteRef,
    title: 'Coûts & FinOps',
    icon: <EuroSymbolIcon />,
    // Pas d'en-tête `PageLayout` (`noHeader: true`) : `CostPage` rend déjà
    // son propre `<Page><Header>` — sans ce réglage, la page afficherait
    // deux en-têtes empilés, ce qui serait un changement visible.
    noHeader: true,
    loader: () =>
      import('./components/CostPage').then(m => (
        <RequirePermission permission={costReadPermission}>
          <m.CostPage />
        </RequirePermission>
      )),
  },
});

const costApi = ApiBlueprint.make({
  params: define =>
    define({
      api: costApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CostClient({ discoveryApi, fetchApi }),
    }),
});

export default createFrontendPlugin({
  pluginId: 'cost',
  extensions: [costPage, costApi],
});
